import AOS from 'aos';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from './breakpoints';

const selectors = {
  mainCarousel: '[data-splide-carousel]',
  progressBar: '[data-progress-bar]',
};

const initCarousel = (el, options = {}, replaceOptions = false) => {
  const carousel = el.querySelector(selectors.mainCarousel);
  let carouselOptions = {};

  if (carousel) {
    carouselOptions = {
      perPage: 2,
      perMove: 1,
      gap: '1rem',
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
        },
      },
      ...options,
    };

    if (replaceOptions) {
      carouselOptions = { ...options };
    }

    const { progressBar: enableProgressBar, ...splideOptions } =
      carouselOptions;
    const useProgressBar =
      carousel.hasAttribute('data-splide-progress-bar') ||
      enableProgressBar === true;

    const splide = new Splide(carousel, splideOptions);

    if (useProgressBar) {
      const progressBar = carousel.querySelector(selectors.progressBar);
      if (progressBar) {
        const updateProgress = () => {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min((splide.index + 1) / end, 1);
          progressBar.style.transform = `scaleX(${rate})`;
        };
        // Before mount() so the initial `mounted` event runs this (same as MainHeader megamenu).
        splide.on('mounted move', updateProgress);
      }
    }

    const syncArrowsHiddenClass = () => {
      const arrowsEl = carousel.querySelector('.splide__arrows');
      if (!arrowsEl) {
        return;
      }
      const { perPage } = splide.options;
      const shouldHide =
        typeof perPage === 'number' && splide.length <= perPage;
      // Class uses a single hyphen before `hidden` (not BEM `--`) so Tailwind
      // `has-[.splide__arrows-hidden]:…` parses; `--` inside `has-[…]` breaks.
      arrowsEl.classList.toggle('splide__arrows-hidden', shouldHide);
      if (shouldHide) {
        arrowsEl.setAttribute('data-arrows-hidden', '');
      } else {
        arrowsEl.removeAttribute('data-arrows-hidden');
      }
    };

    splide.mount();

    if (splide.length <= splide.options.perPage) {
      splide.options = {
        arrows: false,
      };
    }

    syncArrowsHiddenClass();
    splide.on('updated', syncArrowsHiddenClass);

    splide.on('hidden', () => {
      if (splide.length > splide.options.perPage) {
        splide.options = {
          arrows: true,
        };
      }
      syncArrowsHiddenClass();
    });
    splide.on('visible', () => {
      if (splide.length <= splide.options.perPage) {
        splide.options = {
          arrows: false,
        };
      }
      syncArrowsHiddenClass();
    });

    AOS.refresh();
    return splide;
  }

  return null;
};

export default initCarousel;
